import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/concept',
    name: 'ProjectConcept',
    component: () => import('../views/ProjectConcept.vue'),
  },
  {
    path: '/location',
    name: 'Location',
    component: () => import('../views/Location.vue'),
  },
  {
    path: '/info',
    name: 'ProjectInfo',
    component: () => import('../views/ProjectInfo.vue'),
  },
  {
    path: '/plans',
    name: 'Plans',
    component: () => import('../views/Plans.vue'),
    children: [
      {
        path: '',
        redirect: '/plans/floors',
      },
      {
        path: 'floors',
        name: 'FloorPlans',
        component: () => import('../views/Plans/FloorPlans.vue'),
      },
      {
        path: 'units',
        name: 'UnitPlans',
        component: () => import('../views/Plans/UnitPlans.vue'),
      },
      {
        path: 'compare',
        name: 'Compare',
        component: () => import('../views/Plans/Compare.vue'),
      },
      {
        path: 'matrix',
        name: 'UnitMatrix',
        component: () => import('../views/Plans/UnitMatrix.vue'),
      },
    ],
  },
  {
    path: '/facilities',
    name: 'Facilities',
    component: () => import('../views/Facilities.vue'),
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue'),
    children: [
      {
        path: '',
        name: 'GalleryIndex',
        redirect: '/gallery/exterior',
      },
      {
        path: ':id',
        name: 'GalleryId',
        component: () => import('../views/Gallery/Id.vue'),
      },
    ],
  },
  {
    path: '/animation',
    name: 'Animation',
    component: () => import('../views/Animation.vue'),
  },
  {
    path: '/privileges',
    name: 'Privileges',
    component: () => import('../views/Privileges.vue'),
  },
  {
    path: '/virtual-tours',
    name: 'VirtualTours',
    component: () => import('../views/VirtualTours.vue'),
    redirect: '/virtual-tours/skyview',
    children: [
      {
        path: ':id',
        name: 'VirtualToursId',
        component: () => import('../views/VirtualTours/Id.vue'),
      },
    ],
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/concept',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
